module.exports = __webpack_public_path__ + "assets/images/teacher-resource.27ef681ab471ff5c946c54ef7ebfb000.svg";